import flatpickr from "flatpickr"

export default {
	init() {
		const selector = ".flatpickr-polja input.tr-input-time"
		const initializedClass = "flatpickr-initialized"
		const settings = {
			enableTime: true,
			noCalendar: true,
			dateFormat: "H:i",
			time_24hr: true,
			// Brez readonly: readonly polja so izvzeta iz preverjanja obveznosti (required), poleg tega uro lahko tudi vtipkaš.
			allowInput: true
		}

		const initField = (el) => {
			if (!el || el.classList.contains(initializedClass)) return
			flatpickr(el, settings)
			el.classList.add(initializedClass)
		}

		// Initialize existing fields
		document.querySelectorAll(selector).forEach(initField)

		// Initialize on focus for dynamically created fields
		document.addEventListener("focusin", (e) => {
			const target = e.target
			if (target && target.matches && target.matches(selector)) {
				initField(target)
			}
		})

		// Observe DOM changes to catch fields added without focus
		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				mutation.addedNodes.forEach((node) => {
					if (!(node instanceof HTMLElement)) return
					if (node.matches && node.matches(selector)) {
						initField(node)
					}
					node.querySelectorAll && node.querySelectorAll(selector).forEach(initField)
				})
			})
		})

		observer.observe(document.body, { childList: true, subtree: true })
	}
}
